<div class="flex-column h-100">
  <div class="configuration-wizard-header flex-column">
    <h5
      class="odx-title-5"
      i18n="@@gasWarningCenterConfiguration.selectBaseUnits.header"
      data-testid="gasWarningCenterConfiguration.selectBaseUnits.header"
    >
      Basiseinheiten auswählen
    </h5>

    <app-filter-product (searchEvent)="search($event)"></app-filter-product>
    <div class="required-count-message">
      @if (baseUnitSelectionValid()) {
        <odx-inline-message variant="default">
          <ng-container i18n="@@baseUnits.required.count">Anzahl benötigter Basiseinheiten:</ng-container>
          {{ requiredBaseUnitQuantity() }}
        </odx-inline-message>
      } @else {
        <odx-inline-message variant="danger">
          <ng-container i18n="@@baseUnits.required.count">Anzahl benötigter Basiseinheiten:</ng-container>
          {{ requiredBaseUnitQuantity() }}
        </odx-inline-message>
      }
    </div>
  </div>

  <odx-content-box class="flex-column flex-scroll" odxLayout="flex">
    <div odxLayout="grid 3@desktop 6@tablet 12@phone" class="w-100 mb-36 cards-container">
      @for (baseUnit of filteredBaseUnits(); track baseUnit) {
        <app-product-card-with-quantity
          class="overflow-hidden"
          [productData]="baseUnit.product"
          [showCosts]="showCosts()"
          [imageUrl]="getBaseUnitImageUrl(baseUnit.product)"
          [fallbackImageUrl]="fallbackImageUrl()"
          [selectionMode]="selectionMode"
          [quantity]="getSelectedBaseUnitQuantity(baseUnit.product)"
          (quantityChanged$)="onBaseUnitSelectionChange($event, baseUnit.product)"
        >
          @if (baseUnit.product.id) {
            <div class="feature">
              <p class="p-label odx-text--small" i18n="@@global.partNumber">Sachnummer</p>
              <p class="odx-text--small">{{ baseUnit.product.id }}</p>
            </div>
          }
          @if (baseUnit.powerSupply) {
            <div class="feature">
              <p class="odx-text--small p-label">{{ baseUnit.powerSupply.name }}</p>
              <p class="odx-text--small">{{ baseUnit.powerSupply.value }}</p>
            </div>
          }
          @if (baseUnit.dimensions) {
            <div class="feature">
              <p class="odx-text--small p-label">{{ baseUnit.dimensions.name }}</p>
              <p class="odx-text--small" i18n="@@gasWarningCenterConfiguration.gasWarningCenterCard.dimensions">
                ({{ baseUnit.dimensions.height * 1000 }}mm × {{ baseUnit.dimensions.width * 1000 }}mm ×
                {{ baseUnit.dimensions.depth * 1000 }}mm)
              </p>
            </div>
          }
          @if (baseUnit.degreeProtection) {
            <div class="feature">
              <p class="odx-text--small p-label">{{ baseUnit.degreeProtection.name }}</p>
              <p class="odx-text--small">{{ baseUnit.degreeProtection.value }}</p>
            </div>
          }
          @if (productInfoUrl()) {
            <div class="feature" odxLayout="flex">
              <a odxLink [href]="productInfoUrl()" target="_blank" (click)="$event.stopPropagation()">
                <odx-icon name="document" inline></odx-icon>
                <span i18n="@@global.productDatasheet">Produktdatenblatt</span>
              </a>
            </div>
          }
          <div class="feature" odxLayout="flex">
            @if (type()!.hasExcelsheet) {
              <a
                odxLink
                [href]="'/assets/products/excelsheets/' + type()!.key + '.xlsm'"
                target="_blank"
                (click)="$event.stopPropagation()"
              >
                <odx-icon name="document" inline></odx-icon>
                <span i18n="@@gasWarningCenterConfiguration.gasWarningCenterCard.excelSheetLinkText"
                  >Konfiguration {{ type()!.name }}</span
                >
              </a>
            }
          </div>
        </app-product-card-with-quantity>
      }
    </div>
    @if (filteredBaseUnits().length === 0) {
      <app-refresh-products-hint dataType="Basiseinheiten" i18n-dataType="@@global.baseUnits"></app-refresh-products-hint>
    }
  </odx-content-box>
</div>
